export default class Bat extends PIXI.Container {

    constructor() {
        super();

        this.velocity = new P3.math.Vector2(Math.random(), Math.random());
        this.sleeping = true;

        this._view = new PIXI.AnimatedSprite([P3.assets.texture("bat"), P3.assets.texture("bat1")]);
        this._view.autoUpdate = false;
        this._view.animationSpeed = 8;
        this._view.looping = true;
        this._view.anchor.set(0.5);
        this.addChild(this._view);

        this._view.gotoAndPlay(P3.math.randomInt(0, 1));

    }

    update(dt) {
        this.x += this.velocity.x * dt;
        this.y += this.velocity.y * dt;

        if (!this.sleeping)
            this._view.update(dt);
    }

}